
import FileEntry from "./FileEntry.vue";

export default {
  name: "FileList",
  components: { FileEntry },
  props: {
    entries: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onEntryClicked(e) {
      this.$emit("entry-clicked", { ...e });
    },
  },
};
